export default "__VITE_ASSET__bf1344c5__"